export const projectQueryKeys = {
  all: ["gge-project"] as const,
  detail: (id: string | undefined) => [...projectQueryKeys.all, "detail", id] as const,
  primaryModels: (id: string | undefined) => [...projectQueryKeys.all, "primary-models", id] as const,
  meta: (id: string | undefined) => [...projectQueryKeys.all, "meta", id] as const,
  assignedUsers: (id: string | undefined) => [...projectQueryKeys.all, "assigned-users", id] as const,
  groupsAndMeta: (projectId?: string) => [...projectQueryKeys.all, "groups-meta", projectId] as const,
  search: (isArchived: boolean) => [...projectQueryKeys.all, "search", isArchived] as const,
};
